import React from 'react';
import ReactDOM from 'react-dom';
import app from "../../reducers";
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { historyMiddleware } from "../../Middlewares/History.middleware";
import { Provider } from 'react-redux';
import NewsBlockContainer from '../Blocks/NewsBlock/NewsBlock.container';
import VideoBlockContainer from '../Blocks/VideoBlock/VideoBlock.container';
import Header from "../Components/Header/Header";
import UspBlock from "../Blocks/UspBlock/UspBlock";
import Slider from "./slider/Slider";
import CookieBanner from '../Components/CookieBanner/CookieBanner';
import LogotypeBlockContainer from "../Blocks/LogotypeBlock/LogotypeBlock.container";
import { BrowserSize } from '../../Services/BrowserSize';
import HistoryBlockContainer from "../Blocks/HistoryBlock/HistoryBlock.container";
import HoldingsPage from "../Pages/HoldingsPage/HodlingsPage";
import AnnualMagazine from "../Pages/AnnualMagazinePage/AnnualMagazine";
import VideoLibrary from "../Blocks/VideoLibraryBlock/VideoLibrary";
import DynamicComponent from '../../Components/DynamicComponent';
import InvestmentPageContainer from "../Pages/InvestmentPage/InvestmenPage.container";
import InvestmentPage from '../Pages/InvestmentPage/InvestmentPage';
import TimeLineBlockContainer from "../Blocks/TimeLineBlock/TimeLineBlock.container";
import FMGFormBlockContainer from "../Blocks/FMGFormBlock/FMGFormBlock.container";

const preloadState = window.__litium.preloadState || {};
const store = createStore(
    app,
    preloadState,
    composeWithDevTools(applyMiddleware(thunk, historyMiddleware))
);

export const GreatItComponents = () => {
    if (document.getElementsByClassName('--newsBlock--').length > 0) {
        Array.from(document.getElementsByClassName('--newsBlock--')).forEach((block) => {
            const blockId = block.parentElement.getAttribute("data-litium-block-id");
            if (blockId !== "") {
                ReactDOM.render(
                    <Provider store={store}>
                        <NewsBlockContainer {...{ blockId }} />
                    </Provider>,
                    block
                );
            }
        });
    }
    if (document.getElementsByClassName('--videoBlock--').length > 0) {
        Array.from(document.getElementsByClassName('--videoBlock--')).forEach((block) => {
            const blockId = block.parentElement.getAttribute("data-litium-block-id");
            if (blockId !== "") {
                ReactDOM.render(
                    <Provider store={store}>
                        <VideoBlockContainer {...{ blockId }} />
                    </Provider>,
                    block
                );
            }
        });
    }
    if (document.getElementsByClassName('--logotypeBlock--').length > 0) {
        Array.from(document.getElementsByClassName('--logotypeBlock--')).forEach((block) => {
            const blockId = block.parentElement.getAttribute("data-litium-block-id");
            if (blockId !== "") {
                ReactDOM.render(
                    <Provider store={store}>
                        <LogotypeBlockContainer {...{ blockId }} />
                    </Provider>,
                    block
                );
            }
        });
    }

    if (document.getElementById("browserSizeComponent")) {
        ReactDOM.render(
            <Provider store={store}>
                <BrowserSize />
            </Provider>,
            document.getElementById("browserSizeComponent")
        );
    }

    if (document.getElementById("cookieBanner")) {
        //Disable cookie banner and using CookieBot instead
        /* ReactDOM.render(
            <Provider store={store}>
                <CookieBanner />
            </Provider>,
            document.getElementById("cookieBanner")
        ); */
    }

    if (document.getElementsByClassName('--historyBlock--').length > 0) {
        Array.from(document.getElementsByClassName('--historyBlock--')).forEach((block) => {
            const blockId = block.parentElement.getAttribute("data-litium-block-id");
            if (blockId !== "") {
                ReactDOM.render(
                    <Provider store={store}>
                        <HistoryBlockContainer {...{ blockId }} />
                    </Provider>,
                    block
                );
            }
        });
    }

    if (document.getElementById('newsOverviewPage')) {
        const NewsOverviewList = DynamicComponent({
            loader: () => import('../Pages/NewsOverviewPage/NewsOverviewListContainer'),
        });
        ReactDOM.render(
            <Provider store={store}>
                <NewsOverviewList />
            </Provider>,
            document.getElementById('newsOverviewPage')
        );
    }

    if (document.getElementById("investmenPage")) {
        const InvestmentPageComponent = DynamicComponent({
            loader: () => import('../Pages/InvestmentPage/InvestmenPage.container'),
        });
        ReactDOM.render(
            <Provider store={store}>
                <InvestmentPageComponent />
            </Provider>,
            document.getElementById('investmenPage')
        );
    }

    if (document.getElementById('videoPage')) {
        const VideoPage = DynamicComponent({
            loader: () => import('../Pages/VideoPage/VideoPage.container'),
        });
        const videoPageNode = document.getElementById('videoPage');
        const tagList = videoPageNode.getAttribute('data-list');
        ReactDOM.render(
            <Provider store={store}>
                <VideoPage tagList={tagList} />
            </Provider>,
            document.getElementById('videoPage')
        );
    }

    if (document.getElementsByClassName('--timeLineBlock--').length > 0) {
        Array.from(document.getElementsByClassName('--timeLineBlock--')).forEach((block) => {
            const blockId = block.parentElement.getAttribute("data-litium-block-id");
            if (blockId !== "") {
                ReactDOM.render(
                    <Provider store={store}>
                        <TimeLineBlockContainer {...{ blockId }} />
                    </Provider>,
                    block
                );
            }
        });
    }
    
    if (document.getElementsByClassName('FMGFormBlock').length > 0) {
        Array.from(document.getElementsByClassName('FMGFormBlock')).forEach((block) => {
            const blockId = block.parentElement.getAttribute("data-litium-block-id");
            if (blockId !== "") {
                ReactDOM.render(
                    <Provider store={store}>
                        <FMGFormBlockContainer {...{ blockId }} />
                    </Provider>,
                    block
                );
            }
        });
    }
}
